import React, { Component } from 'react';

class Closings extends Component {
  constructor(props){
    super(props);
    this.affiliate = this.props.affliate;

  }

  componentWillMount(){
    if(this.props.banners)
      this.setState(this.props.banners)

  }

  componentWillReceiveProps(nextProps){
    this.setState(nextProps.banners)
  }


  render(){
    if(!this.state.schoolsClosed)
      return null
    return (<div className={'gnm-closings ' +(this.state.schoolsClosed? 'schools-closed' : '')}>
      <div className='container'>
        <span className='closings pull-left'>
          <a href={this.state.schoolClosingUrl}>School Closings <i ><span>{this.props.closingsSponsorship}</span></i></a>
        </span>
      </div>
    </div>)
  }
}

export default Closings;



// WEBPACK FOOTER //
// ./app/components/custom/ssr/Header/Closings.js